"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFinalForm = require("react-final-form");

var _TextFieldAdapter = _interopRequireDefault(require("../../Adapters/TextFieldAdapter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailFieldComponent = function EmailFieldComponent(props) {
  var name = props.name;

  if (name === undefined) {
    name = "email";
  }

  var isValid = function isValid(email) {
    //RFC-5322 https://www.ietf.org/rfc/rfc5322.txt http://emailregex.com/
    var re = // eslint-disable-next-line no-control-regex
    /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    return email && re.test(email.toLowerCase()) ? undefined : "Please enter a valid email address";
  };

  var stripSpaces = function stripSpaces(value) {
    return value && value.replace(/ /g, "");
  };

  return /*#__PURE__*/_react.default.createElement(_reactFinalForm.Field, {
    name: name,
    label: "Email",
    validate: isValid,
    component: _TextFieldAdapter.default,
    subscription: {
      touched: true,
      value: true,
      error: true
    },
    parse: stripSpaces,
    inputProps: {
      maxLength: 50
    },
    fullWidth: true,
    required: true
  });
};

var _default = EmailFieldComponent;
exports.default = _default;